module.exports = __webpack_public_path__ + "img/unmarked-test.f3089847.svg";